var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('v-textarea',_vm._b({class:{
      'input--align-right': _vm.alignRight,
      'input--has-error': errors.length > 0
    },attrs:{"id":_vm.fieldId,"error-messages":errors,"hide-details":errors.length === 0,"label":_vm.fieldLabelWithSupplement,"placeholder":_vm.fieldPlaceholder,"data-testid":"app-textarea__input","outlined":""},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}},'v-textarea',_vm.$attrs,false))]}}])},'ValidationProvider',_vm.validationProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }